import { Users, UserCheck, TrendingUp, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  trend: string;
  trendUp: boolean;
  icon: React.ElementType;
  iconColor: string;
  iconBg: string;
  delay?: number;
}

function StatCard({
  title,
  value,
  trend,
  trendUp,
  icon: Icon,
  iconColor,
  iconBg,
  delay = 0,
}: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="bg-white dark:bg-slate-900/50 rounded-2xl p-6 border border-slate-200 dark:border-slate-800 shadow-sm flex items-center gap-6 group hover:border-primary/30 transition-colors"
    >
      <div
        className={cn(
          "h-14 w-14 rounded-2xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-110",
          iconBg,
        )}
      >
        <Icon className={cn("h-6 w-6", iconColor)} />
      </div>
      <div>
        <h3 className="text-sm font-semibold text-slate-500 dark:text-slate-400 mb-1">
          {title}
        </h3>
        <p className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
          {value}
        </p>
        <div className="flex items-center gap-1.5 text-xs font-medium">
          <span className={cn(trendUp ? "text-emerald-500" : "text-rose-500")}>
            {trendUp ? "↑" : "↓"} {trend}
          </span>
          <span className="text-slate-400">from last month</span>
        </div>
      </div>
    </motion.div>
  );
}

export function CandidatesHeader() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
          Candidates
        </h1>
        <p className="text-slate-600 dark:text-slate-400">
          Manage and view all candidate users in your organization.
        </p>
      </div>

      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard 
          title="Total Candidates"
          value="24,658"
          trend="15.3%"
          trendUp={true}
          icon={Users}
          iconColor="text-indigo-600 dark:text-indigo-400"
          iconBg="bg-indigo-50 dark:bg-indigo-500/10"
          delay={0.1}
        />
        <StatCard 
          title="Active Candidates"
          value="18,542"
          trend="12.8%"
          trendUp={true}
          icon={UserCheck}
          iconColor="text-blue-600 dark:text-blue-400"
          iconBg="bg-blue-50 dark:bg-blue-500/10"
          delay={0.2}
        />
        <StatCard 
          title="New This Month"
          value="2,345"
          trend="8.2%"
          trendUp={true}
          icon={TrendingUp}
          iconColor="text-emerald-600 dark:text-emerald-400"
          iconBg="bg-emerald-50 dark:bg-emerald-500/10"
          delay={0.3}
        />
        <StatCard 
          title="Hired"
          value="842"
          trend="10.1%"
          trendUp={true}
          icon={CheckCircle}
          iconColor="text-green-600 dark:text-green-400"
          iconBg="bg-green-50 dark:bg-green-500/10"
          delay={0.4}
        />
      </div> */}
    </div>
  );
}
